var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mandate-item" },
    [
      _c("div", { staticClass: "mandate-item__left" }, [
        _c(
          "div",
          { staticClass: "mandate-item__header" },
          [
            _c(
              "div",
              { staticClass: "typographies-paragraph-medium-regular" },
              [_vm._v(_vm._s(_vm.mandate.number))]
            ),
            _vm._v(" "),
            _vm.mandate.status === "revoked"
              ? _c(
                  "CompassTag",
                  { attrs: { color: "yellow", size: "small" } },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t.__("common.labels.revoked")) +
                        "\n            "
                    )
                  ]
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mandate-item__types" },
          _vm._l(_vm.mandate.types, function(type) {
            return _c(
              "CompassTag",
              { key: type, attrs: { color: "stroked" } },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t.__("settings.mandate.type." + type)) +
                    "\n            "
                )
              ]
            )
          }),
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mandate-item__right" }, [
        _c(
          "div",
          { staticClass: "mandate-item__actions" },
          [
            _vm.mandate.status === "pending"
              ? [
                  _c("CompassButton", {
                    attrs: {
                      label: _vm.$t.__("settings.mandate.button.cancel"),
                      type: "tertiary-destructive"
                    },
                    on: { click: _vm.cancelMandate }
                  }),
                  _vm._v(" "),
                  _c("CompassButton", {
                    attrs: {
                      label: _vm.$t.__("settings.mandate.button.send_again"),
                      leftIcon: "bell",
                      type: "secondary",
                      loading: _vm.isSendingEmail
                    },
                    on: { click: _vm.resendSignatureEmail }
                  })
                ]
              : _vm.mandate.status === "ok" && _vm.mandate.pdf_link
              ? _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("settings.mandate.button.download"),
                    leftIcon: "download"
                  },
                  on: { click: _vm.downloadMandate }
                })
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "mandate-item__legal-rep" }, [
          _vm.mandate.status === "pending"
            ? _c("p", { staticClass: "typographies-paragraph-small-regular" }, [
                _c(
                  "strong",
                  { staticClass: "typographies-paragraph-small-bold" },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t.__("settings.mandate.pending")) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$t.__("settings.mandate.sent_to", {
                        email: _vm.mandate.legal_representative_email
                      })
                    ) +
                    "\n            "
                )
              ])
            : _vm.mandate.status === "ok"
            ? _c("p", { staticClass: "typographies-paragraph-small-bold" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$t.__("settings.mandate.signed_at", {
                        date: _vm.$filters.saasDateFormatted(
                          _vm.mandate.signed_at
                        ),
                        name:
                          _vm.mandate.legal_representative_first_name +
                          " " +
                          _vm.mandate.legal_representative_last_name
                      })
                    ) +
                    "\n            "
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.showDeleteDialog
        ? _c("MandateDeleteDialog", {
            on: {
              mandateDeleted: function($event) {
                return _vm.$emit("mandateDeleted")
              },
              close: function($event) {
                _vm.showDeleteDialog = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }